module.exports = __webpack_public_path__ + "static/media/Hausmart_logo_notype_white.27127c19.svg";